import styled from 'styled-components';
import {
	flexColumn, 
	flexRow
} from '../../../style/Global';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import {
    device
} from '../../../style/breakpoints';

export const CheckboxesContainer = styled.div`
    @media ${device.tablet} {
        overflow-y:scroll;
        order:3;
    }
`

export const ComponentContainer = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-flow: column;
    min-height: 0;
    // overflow-y: auto;
    // overflow-x: hidden;
    width: 100%;
`;

export const FormControlSongsList = styled(FormControl)`
    margin: theme.spacing(1);
    minWidth: 120;
`;

export const ListYoutubeContainer = styled.div`
    ${flexRow}
    height:90%;
    overflow-y:auto;
    @media ${device.tablet} {
        ${flexColumn}
        justify-content:space-between;
        height:100%;
    }
`;

export const SongButton = styled(Button)`
    padding:5px;
`;

export const SongButtonsContainer = styled.div`
    ${flexColumn}
    flex: 0 0 150px;
`;

export const SongInfoContainer = styled.div`

`;

export const SongsListContainer = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-flow: column;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
    // height:75vh;
    // @media ${device.tablet} {
    //     height:60vh;
    //     // width:90%;
    // }
`;

export const SongsListLi = styled.li`
    ${flexRow}
    align-self: flex-start;
    cursor: pointer;
    flex: 1 1 auto;
    justify-content: space-between;
    // margin: 5px;
    min-height: 71px;
    overflow: hidden;
    padding:10px;
    position: relative;
    width:100%;

    @media ${device.tablet} {
        padding:0px;
        margin-bottom:2px;
    }
`;

export const SongsListUl = styled.ul`
    ${flexColumn}
    flex: 0 0 auto;
    justify-content: flex-start;
    min-height: 0;
    padding:0px;
    width: 100%;
`;

export const YoutubeContainer = styled.div`
    flex: 0 0 30%;
    @media ${device.tablet} {
        ${flexColumn}
        justify-content: flex-end;
        // flex: 1 1 auto;
        // height:calc(100% - 200px);
        order:1;
        flex: 0 0 25%;
    }
`